/**
 * 键盘快捷键 Mixin
 * 提供快捷键注册和自动清理功能
 */
import keyboardShortcuts from '@/utils/keyboardShortcuts'

export default {
  computed: {
    // 导出工具方法供模板使用
    $shortcuts() {
      return keyboardShortcuts
    }
  },

  created() {
    // 在 created 钩子中初始化数组,确保实例属性正确设置
    this._shortcutUnsubscribers = []
  },

  methods: {
    /**
     * 注册快捷键
     * @param {String} key - 按键
     * @param {Function} callback - 回调函数
     * @param {Object} options - 配置选项
     */
    $registerShortcut(key, callback, options) {
      // 确保数组已初始化
      if (!this._shortcutUnsubscribers) {
        this._shortcutUnsubscribers = []
      }

      const unsubscribe = keyboardShortcuts.register(key, callback, options)
      this._shortcutUnsubscribers.push(unsubscribe)
      return unsubscribe
    },

    /**
     * 格式化快捷键显示
     * @param {String} key - 按键
     * @param {Boolean} requireModifier - 是否需要修饰键
     */
    $formatShortcut(key, requireModifier = true) {
      return keyboardShortcuts.formatShortcut(key, requireModifier)
    }
  },

  beforeDestroy() {
    // 自动清理所有快捷键监听器
    if (this._shortcutUnsubscribers) {
      this._shortcutUnsubscribers.forEach(unsubscribe => unsubscribe())
      this._shortcutUnsubscribers = []
    }
  }
}
